import { css, styled } from "styled-components";
import { mobileBreakPointCSS } from "../../defaults/theme.js";

export const Wrapper = styled.div`
  background-color: var(--swatch3);
  color: var(--swatch2);
  padding: ${(props) => `${props.theme.spacing.l} 0 ${props.theme.spacing.xl}`};

  .back {
    margin-bottom: ${(props) => props.theme.spacing.s};
  }

  @media (min-width: 1050px) {
    .back {
      margin-bottom: ${(props) => props.theme.spacing.m};
    }
  }
`;

export const Layout = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing.m};

  > * {
    display: flex;
    flex-direction: column;
    gap: ${(props) => props.theme.spacing.m};
  }

  > * {
    flex: 3;
  }

  > *:first-child  {
    flex: 4;
  }

  @media (min-width: 1050px) {
    flex-direction: row-reverse;
  }
`;

export const Card = styled.div.attrs({ className: "h6" })`
  background-color: #fff;
  color: var(--swatch2);
  padding: ${(props) => props.theme.spacing.m};
  border-radius: 10px;

  > *:first-child {
    margin-top: 0;
  }

  > *:last-child {
    margin-bottom: 0;
  }

  @media (min-width: 1050px) {
    padding: ${(props) => props.theme.spacing.l};
  }
`;

export const Expander = styled.a<{ $expanded?: boolean }>`
  display: flex;
  justify-content: space-between;
  color: var(--swatch2);
  text-decoration: none;

  svg {
    width: 24px;
    height: 24px;
    transform: ${(props) =>
      props.$expanded ? "rotate(-90deg)" : "rotate(90deg)"};

    path {
      fill: var(--swatch2);
    }
  }

  @media (min-width: 1050px) {
    svg {
      display: none;
    }
  }
`;

export const OrderSummary = styled.div<{ $expanded?: boolean }>`
  display: none;

  @media (min-width: 1050px) {
    display: block;
  }

  ${(props) =>
    props.$expanded &&
    css`
      display: block;
    `}
`;

export const OrderSummaryItem = styled.div`
  display: flex;
  gap: ${(props) => props.theme.spacing.m};
  border-bottom: 1px solid var(--swatch1);
  padding-bottom: ${(props) => props.theme.spacing.m};
  margin-top: ${(props) => props.theme.spacing.m};

  img {
    width: 54px;
    height: 54px;
  }

  p {
    margin: 0;
  }

  p:not(:last-child) {
    margin-bottom: ${(props) => props.theme.spacing.xs};
  }

  .line-info {
    flex: 1;
  }

  .line-cost {
    text-align: right;
  }

  .line-cost-compare {
    text-decoration: line-through;
  }

  a {
    font-size: 0.85em;
    color: var(--swatch1);
    text-decoration: none;
    text-transform: uppercase;
  }
`;

export const Total = styled.div.attrs({ className: "h4" })`
  display: flex;
  gap: ${(props) => props.theme.spacing.m};
  justify-content: space-between;
  align-items: center;
  height: 4em;
  padding: 0 ${(props) => props.theme.spacing.l};
  margin-top: ${(props) => props.theme.spacing.m};
  border-radius: 0 30px;
  background-color: var(--swatch4);
  color: var(--swatch2);

  @media (min-width: 1050px) {
    margin: ${(props) => props.theme.spacing.l} 0;
  }
`;

export const DiscountCode = styled.form``;

export const DiscountCodeButtonWrapper = styled.div`
  text-align: right;
  margin-top: ${(props) => props.theme.spacing.m};

  @media (min-width: 1050px) {
    text-align: center;
  }
`;

export const ButtonList = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing.m};
  margin-top: ${(props) => props.theme.spacing.m};

  @media (min-width: 1050px) {
    margin-top: ${(props) => props.theme.spacing.l};
    justify-content: space-between;
    flex-direction: row;
  }
`;

export const OrderWrapper = styled.div`
  @media (max-width: ${mobileBreakPointCSS}) {
    table {
      margin-left: -${(props) => props.theme.spacing.m};
      margin-right: -${(props) => props.theme.spacing.m};
    }

    table {
      width: calc(100vw - (${(props) => props.theme.spacing.m} * 2));
    }
  }
`;
